export const BUS_APP_LAUNCH = 'launch-app'
export const ITEM_VIEW_CLOSE = 'item-view:close'
export const PROJECT_ITEM_VIEW_CLOSE = 'project-item-view:close'